import React, {useState} from 'react';
import { CardBody,  Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";
import {useForm} from "react-hook-form";
import SelectGeneric from "../../../components/select/selectGeneric";
import {placeProvider} from "../../../providers/placeProvider";
import Switch from "react-bootstrap-switch";

export default function RoomFilters(props) {
	const {register, handleSubmit, reset} = useForm();
	const udn = JSON.parse(localStorage.getItem('selectedUdn'))
	const [placeId, setPlaceId] = useState(null);
	const [status, setStatus] = useState(null);
	const [isSpecial, setIsSpecial] = useState(null);

	const onSubmit = (data, _) => {
		const dataFilter = {
			level : data.level,
			number : data.number,
		};

		if (placeId !== undefined && placeId !== null){
			dataFilter.place = { id : placeId };
		}

		if (status !== undefined && status !== null){
			dataFilter.status = status;
		}

		if (isSpecial !== undefined && isSpecial !== null){
			dataFilter.isSpecial = isSpecial;
		}

		props.refreshFiltered(dataFilter);
	};

	const cleanFields = () => {
		setStatus(null);
		setIsSpecial(null);
		setPlaceId(null);
		reset();
	}

	return (
		<Form onSubmit={handleSubmit(onSubmit)}>
			<CardBody className="">
				<Row>
					<Col md="4">
						<FormGroup>
							<Label htmlFor="place">Lugar o edificio</Label>
							<SelectGeneric
								initialValue={ placeId }
								setExternalValue={  value => setPlaceId( value ) }
								provider = { placeProvider }
								customFilter={{item: {udn: {id: udn.id}}} }
							/>
						</FormGroup>
					</Col>
					<Col md="2">
						<FormGroup>
							<Label>Nivel </Label>
							<Input type="number" name="level"
							       placeholder="Busqueda por nivel"
							       innerRef={register}/>
						</FormGroup>
					</Col>
					<Col md="2">
						<FormGroup>
							<Label>Numero de cuarto</Label>
							<Input type="text" name="number"
							       placeholder="Busqueda por numero de cuarto"
							       innerRef={register}/>
						</FormGroup>
					</Col>

					<Col md="2">
						<FormGroup>
							<Label>Es especial</Label>
							<br/>
							<Switch animate={true} offText={"No"} onText={"Si"}
							        value={isSpecial}
							        onChange={_ => setIsSpecial(!isSpecial)}
							/>
						</FormGroup>
					</Col>

					<Col md="2">
						<FormGroup>
							<Label>Activo</Label>
							<br/>
							<Switch animate={true} offText={"No"} onText={"Si"}
							        value={status}
							        onChange={_ => setStatus(!status)}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md="12" className="d-flex justify-content-center">
						<div className="float-right">
							<ButtonSearch/>
							<ButtonClean onClick={() => cleanFields()}/>
						</div>
					</Col>
				</Row>
			</CardBody>
		</Form>
	)
}